import React from 'react';
import { IPFieldProps } from '../../types/field-props';
import CImage from '../types/CImage';

export const UXImage = (props: IPFieldProps<CImage>): JSX.Element => {
    return <>
        <img
            src={props.field.url}
        />
    </>
}